import { c as _c } from "react/compiler-runtime";
import LanguageRoundedIcon from '@mui/icons-material/LanguageRounded';
import AppBar, { AppBarProps } from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import dynamic from 'next/dynamic';
import Image from 'next/image';
import NextLink from 'next/link';
import { MouseEventHandler, ReactElement, useState } from 'react';
import logo from '../assets/logo.svg';
const DynamicLanguageSwitchDialog = dynamic(() => import(/* webpackChunkName: "LanguageSwitchDialog" */
'../../LanguageSwitchDialog').then(mod => mod.LanguageSwitchDialog), {
  ssr: false
});
interface LocalAppBarProps extends AppBarProps {
  onMenuClick: MouseEventHandler<HTMLButtonElement>;
  hideSpacer?: boolean;
  menuOpen?: boolean;
  showLanguageSwitcher?: boolean;
}
export function LocalAppBar(t0) {
  const $ = _c(35);
  let onMenuClick;
  let props;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    ({
      onMenuClick,
      hideSpacer: t1,
      menuOpen: t2,
      showLanguageSwitcher: t3,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = onMenuClick;
    $[2] = props;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    onMenuClick = $[1];
    props = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
  }
  const hideSpacer = t1 === undefined ? false : t1;
  const menuOpen = t2 === undefined ? false : t2;
  const showLanguageSwitcher = t3 === undefined ? false : t3;
  const [openLanguagesDialog, setOpenLanguagesDialog] = useState(null);
  const t4 = hideSpacer ? "background.default" : "inherit";
  let t5;
  let t6;
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      lg: "69px"
    };
    t6 = {
      lg: 14
    };
    t7 = {
      xs: 100,
      lg: 159
    };
    $[6] = t5;
    $[7] = t6;
    $[8] = t7;
  } else {
    t5 = $[6];
    t6 = $[7];
    t7 = $[8];
  }
  let t8;
  if ($[9] !== props.sx || $[10] !== t4) {
    t8 = {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      background: "transparent",
      color: t4,
      boxShadow: "none",
      py: 10,
      pt: t5,
      pb: t6,
      height: t7,
      width: "100%",
      ...props.sx
    };
    $[9] = props.sx;
    $[10] = t4;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      px: 8
    };
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      justifyContent: "space-between",
      alignItems: "center",
      flexGrow: 1
    };
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      width: {
        xs: 126,
        lg: 186
      },
      mt: {
        xs: 1.2,
        lg: 3.5
      },
      mb: {
        xs: -1.2,
        lg: -3.5
      },
      zIndex: _temp
    };
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Box component={NextLink} href="https://www.jesusfilm.org/" data-testid="WatchLogo" sx={t11} locale={false}><Image src={logo} alt="Watch Logo" style={{
        cursor: "pointer",
        maxWidth: "100%",
        height: "auto",
        width: "auto"
      }} /></Box>;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] !== openLanguagesDialog || $[17] !== showLanguageSwitcher) {
    t13 = showLanguageSwitcher && <><IconButton color="inherit" aria-label="open language selector" data-testid="LanguageSelector" onClick={() => setOpenLanguagesDialog(true)} sx={{
        mr: 8,
        zIndex: _temp2
      }}><LanguageRoundedIcon sx={{
          fontSize: 39,
          color: "text.secondary"
        }} /></IconButton>{openLanguagesDialog != null && <DynamicLanguageSwitchDialog open={openLanguagesDialog} handleClose={() => setOpenLanguagesDialog(false)} />}</>;
    $[16] = openLanguagesDialog;
    $[17] = showLanguageSwitcher;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  const t14 = menuOpen ? "expanded" : "";
  let t15;
  let t16;
  let t17;
  let t18;
  let t19;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = {
      width: 39,
      height: 30,
      p: 0,
      position: "relative",
      zIndex: _temp3,
      "& span": {
        display: "block",
        position: "absolute",
        width: "100%",
        height: 6,
        borderRadius: 6,
        backgroundColor: "text.secondary",
        opacity: 1,
        left: 0,
        transform: "rotate(0deg)",
        transition: "0.15s ease-in-out",
        "&:nth-of-type(1)": {
          top: 0
        },
        "&:nth-of-type(2)": {
          top: 12
        },
        "&:nth-of-type(3)": {
          top: 12
        },
        "&:nth-of-type(4)": {
          top: 24
        }
      },
      "&.expanded": {
        "& span": {
          "&:nth-of-type(1), &:nth-of-type(4)": {
            top: 15,
            width: "0%",
            left: "50%",
            opacity: 0
          },
          "&:nth-of-type(2)": {
            transform: "rotate(45deg)"
          },
          "&:nth-of-type(3)": {
            transform: "rotate(-45deg)"
          }
        }
      }
    };
    t16 = <span />;
    t17 = <span />;
    t18 = <span />;
    t19 = <span />;
    $[19] = t15;
    $[20] = t16;
    $[21] = t17;
    $[22] = t18;
    $[23] = t19;
  } else {
    t15 = $[19];
    t16 = $[20];
    t17 = $[21];
    t18 = $[22];
    t19 = $[23];
  }
  let t20;
  if ($[24] !== menuOpen || $[25] !== onMenuClick || $[26] !== t14) {
    t20 = <IconButton data-testid="MenuIcon" color="inherit" aria-label="open header menu" edge="start" onClick={onMenuClick} disableRipple={true} className={t14} aria-expanded={menuOpen} sx={t15}>{t16}{t17}{t18}{t19}</IconButton>;
    $[24] = menuOpen;
    $[25] = onMenuClick;
    $[26] = t14;
    $[27] = t20;
  } else {
    t20 = $[27];
  }
  let t21;
  if ($[28] !== t13 || $[29] !== t20) {
    t21 = <Container maxWidth="xxl" disableGutters={true} sx={t9}><Stack direction="row" sx={t10}>{t12}<Box data-testid="MenuBox">{t13}{t20}</Box></Stack></Container>;
    $[28] = t13;
    $[29] = t20;
    $[30] = t21;
  } else {
    t21 = $[30];
  }
  let t22;
  if ($[31] !== props || $[32] !== t21 || $[33] !== t8) {
    t22 = <AppBar data-testid="Header" position="static" {...props} sx={t8}>{t21}</AppBar>;
    $[31] = props;
    $[32] = t21;
    $[33] = t8;
    $[34] = t22;
  } else {
    t22 = $[34];
  }
  return t22;
}
function _temp3(theme_1) {
  return theme_1.zIndex.drawer + 1;
}
function _temp2(theme_0) {
  return theme_0.zIndex.drawer;
}
function _temp(theme) {
  return {
    xs: theme.zIndex.drawer + 1,
    lg: 0
  };
}